<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />

    <b-row>
      <b-col cols="6" offset="1">
        <h1 class="my-5">Media Search</h1>

        <b-input-group>
          <b-form-input
            @keyup.enter="submitSearch()"
            v-model="searchEntityNameText"
            type="text"
            placeholder="Enter the entity name you would like to search..."
          ></b-form-input>

          <b-input-group-append>
            <b-button variant="outline-success" @click="submitSearch()">Search</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button v-b-toggle.collapse-2 variant="primary">
              <font-awesome-icon icon="cog" />
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <b-collapse id="collapse-2" class="mt-2">
          <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
            <h4 class="text-left">Advanced filters</h4>
            <div class="text-left">
              <b-form-checkbox v-model="sort" value="1">Order by latest</b-form-checkbox>
              <b-form-checkbox v-model="exactTerms" value="1">Exact Phrase Match</b-form-checkbox>
              <b-form-group label="Index from">
                <b-form-select v-model="selectedStart" :options="startOptions"></b-form-select>
              </b-form-group>
            </div>
            <b-row>
              <b-col cols="6">
                <h4 class="mt-3 text-left">Keyword search and phrases</h4>
                <b-input-group class="mt-3">
                  <b-form-input
                    placeholder="Enter the entity name you would like to search..."
                    @keyup.enter="addAdditionalKeywordPhrases()"
                    v-model="name"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addAdditionalKeywordPhrases" variant="outline-warning">Add</b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-form-checkbox-group
                  class="text-left mt-3"
                  :options="keywords"
                  stacked
                  v-model="selectedKeywords"
                ></b-form-checkbox-group>
              </b-col>
              <b-col cols="6">
                <h4 class="mt-3 text-left">Exclude Keyword search and phrases</h4>
                <b-input-group class="mt-3">
                  <b-form-input
                    placeholder="Enter the entity name you would like to search..."
                    @keyup.enter="addAdditionalExcludeKeywordPhrases()"
                    v-model="excludeTerm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      @click="addAdditionalExcludeKeywordPhrases"
                      variant="outline-warning"
                    >Add</b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-form-checkbox-group
                  class="text-left mt-3"
                  :options="excludeTerms"
                  stacked
                  v-model="selectedExcludeTerms"
                ></b-form-checkbox-group>
              </b-col>
              <b-col cols="6">
                <h4 class="mt-3 text-left">Language</h4>
                <b-form-radio-group
                  class="text-left mt-3"
                  :options="languageOptions"
                  stacked
                  v-model="selectedLanguage"
                ></b-form-radio-group>
              </b-col>

              <!-- <div >
                    <b-list-group v-for="(keyword, index) in keywords" :key="index">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            {{keyword}}
                            <div>
                                <font-awesome-icon
                v-b-tooltip.hover
                title="Delete"
                icon="trash"
                :class="'ml-2 text-danger'"
                @click="removeName(index)"
              />

                                

                            </div>
                        </b-list-group-item>
                    </b-list-group>
              </div>-->
            </b-row>
          </b-card>
        </b-collapse>
      </b-col>
      <b-col cols="5" style="height:calc(100vh - 100px); overflow-y:auto;">
        <h3>Results ({{items.length || 0}})</h3>
        <!-- <div v-for="(item,index) in items" :key="index" >
          <p>{{item.title}}</p>
          <p>{{item.link}}</p>
           <p>{{item.displayLink}}</p>
          <p>Date Published: {{getDateFromArticle(item)}}</p>
          <hr>
           
        </div>-->
        <SearchResult
          v-for="(item,index) in items"
          :key="index"
          :resultData="item"
          :resultIndex="index"
          :keywords="keywords"
        ></SearchResult>
      </b-col>
      <b-alert
        v-model="showErrorToast"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000;"
        variant="danger"
        dismissible
        solid
      >Error</b-alert>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import AppLoader from "../components/Loader/Loader";
import SearchResult from "../components/negative-media/search-results.vue";
export default {
  name: "mediaSearchPage",
  components: {
    SearchResult,
    AppLoader
  },
  data() {
    return {
      showErrorToast: false,
      searchEntityNameText: null,
      name: null,
      keywords: [
        { text: "bribery", value: "bribery" },
        { text: "bribed", value: "bribed" },
        { text: "bribing", value: "bribing" },
        { text: "accused", value: "accused" },
        { text: "fined", value: "fined" },
        { text: "sanctioned", value: "sanctioned" },
        { text: "sanctions", value: "sanctions" },
        { text: "enforcement", value: "enforcement" },
        { text: "charged", value: "charged" },
        { text: "ofac", value: "ofac" }
      ],
      excludeTerms: [
        { text: "kingpin", value: "kingpin" },
        { text: "Career", value: "career" }
      ],
      excludeTerm: null,
      selectedKeywords: [
        "bribery",
        "bribed",
        "bribing",
        "accused",
        "fined",
        "sanctions",
        "sanctioned",
        "enforcement",
        "charged",
        "ofac"
      ],
      selectedExcludeTerms: ["kingpin", "career"],
      isEditing: false,
      selectedIndex: null,
      totalResults: null,
      items: [],
      isLoading: false,
      sort: 0,
      selectedStart: 1,
      startOptions: [
        { value: 1, text: "1 to 10" },
        { value: 11, text: "11 to 20" },
        { value: 21, text: "21 to 30" },
        { value: 31, text: "31 to 40" },
        { value: 41, text: "41 to 50" },
        { value: 51, text: "51 to 60" },
        { value: 61, text: "61 to 70" },
        { value: 71, text: "71 to 80" },
        { value: 81, text: "81 to 90" },
        { value: 91, text: "91 to 100" }
      ],
      exactTerms: 0,
      selectedLanguage: "lang_en",
      languageOptions: [
        { value: "lang_en", text: "English" },
        { value: "lang_ar", text: "Arabic" },
        { value: "lang_bg", text: "Bulgarian" },
        { value: "lang_ca", text: "Catalan" },
        { value: "lang_cs", text: "Czech" },
        { value: "lang_da", text: "Danish" },
        { value: "lang_de", text: "German" },
        { value: "lang_el", text: "Greek" },
        { value: "lang_es", text: "Spanish" },
        { value: "lang_et", text: "Estonian" },
        { value: "lang_fi", text: "Finnish" },
        { value: "lang_fr", text: "French" },
        { value: "lang_hr", text: "Croatian" },
        { value: "lang_hu", text: "Hungarian" },
        { value: "lang_id", text: "Indonesian" },
        { value: "lang_is", text: "Icelandic" },
        { value: "lang_it", text: "Italian" },
        { value: "lang_iw", text: "Hebrew" },
        { value: "lang_ja", text: "Japanese" },
        { value: "lang_ko", text: "Korean" },
        { value: "lang_lt", text: "Lithuanian" },
        { value: "lang_lv", text: "Latvian" },
        { value: "lang_nl", text: "Dutch" },
        { value: "lang_no", text: "Norwegian" },
        { value: "lang_pl", text: "Polish" },
        { value: "lang_pt", text: "Portuguese" },
        { value: "lang_ro", text: "Romanian" },
        { value: "lang_ru", text: "Russian" },
        { value: "lang_sk", text: "Slovak" },
        { value: "lang_sl", text: "Slovenian" },
        { value: "lang_sr", text: "Serbian" },
        { value: "lang_sv", text: "Swedish" },
        { value: "lang_tr", text: "Turkish" },
        { value: "lang_zh-CN", text: "Chinese (Simplified)" },
        { value: "lang_zh-TW", text: "Chinese (Traditional)" }
      ]
    };
  },
  methods: {
    getDateFromArticle(article) {
      let snippet = article.snippet;
      let data = snippet.split("...");
      return data[0];
    },
    addAdditionalKeywordPhrases() {
      let set = {
        value: this.name,
        text: this.name
      };
      this.keywords.unshift(set);
      this.selectedKeywords.push(set.value);
      this.name = null;
      // console.log(this.keywords);
    },
    addAdditionalExcludeKeywordPhrases() {
      let set = {
        value: this.excludeTerm,
        text: this.excludeTerm
      };
      this.excludeTerms.unshift(set);
      this.selectedExcludeTerms.push(set.value);
      this.excludeTerm = null;
    },
    removeName(index) {
      this.keywords.splice(index, 1);
    },

    async submitSearch() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.items = [];
      try {
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/negativemedia/search",
          {
            searchEntityNameText: this.searchEntityNameText,
            keywordPhraseMatch: this.selectedKeywords,
            exactTerms: this.exactTerms,
            excludeTerms: this.selectedExcludeTerms,
            language: this.selectedLanguage,
            start: this.selectedStart,
            sort: this.sort
          },
          {
            Authorization: token
          },
          null,
          true
        );
        this.totalResults = result.data.results.searchInformation.totalResults;
        this.items = result.data.results.items || [];
        this.isLoading = false;
        // console.log(result.data);
      } catch {
        this.isLoading = false;
        this.showErrorToast = true;
      }
    }
  }
};
</script>
